import { useState } from "react";
import { H3, Label } from "../Text";
import { toast } from "react-toastify";
import Circle from "../Animation/Circle";
import { Button } from "../Buttons";
import { Request } from "../../hooks/Request";
import TableComplete from "../Tables/TableComplete";
import { requestAuth } from "../services/RequestService";
import { useDialog } from "../../contexts/DialogContext";
import { DialogConfirmation } from "../Modal";
import CreatableSelect from "react-select/creatable";
import { validateArray } from "../../utils/validate";
import { FormDetailsDocument } from "./FormDetailsDocument";

const InputSubContaMultiAdd = ({ field }) => {
  const { openDialog, dialogClose } = useDialog();

  const { data, loading, call } = Request({
    urlApi: `/dataSet/procedure/${field.id}/field/${field.fieldId}/subdata`,
  });
  console.log("👉 field recibido:", field);
  console.log("d: ", data)
  const {
    data: document,
    loading: loadDocument,
    call: callDocument,
  } = Request({
    urlApi: field.urlApi,
  });

  console.log("do, ", document)

  function handleForm(item) {
    openDialog(
      <>
        {loadDocument && (
          <div className="min-h-[360px]">
            <FormAddDocument
              data={document}
              item={item}
              reload={call}
              field={field}
              onClose={dialogClose}
              callDocument={callDocument}
            />
          </div>
        )}
      </>
    );
  }

  function handleFormItems(item) {
    openDialog(
      <>
        {loadDocument && (
          <div className="">
            <FormDetailsDocument
              // data={document}
              item={item}
              reload={call}
              // field={field}
              onClose={dialogClose}
              // callDocument={callDocument}
            />
          </div>
        )}
      </>
    );
  }

  function handleDelete(data) {
    openDialog(
      <DialogConfirmation
        children={<H3>¿Estas seguro que quieres eliminar este item?</H3>}
        onClose={dialogClose}
        method="delete"
        url={`/dataSet/procedure/subData/${data.id}`}
        texBtn="Eliminar"
        handleSuccess={call}
      />
    );
  }

  return (
    <div className="bg-gray-300/40 p-2 rounded-md">
      <Label htmlFor={field.name} className={`${field.className} my-0`}>
        {field.labelCustom ? field.labelCustom : field.label}
      </Label>
      <div className="bg-gray-100 rounded-lg p-3 pt-2">
        {loadDocument && (
          <FormAddDocument
            data={document}
            reload={call}
            field={field}
            onClose={() => {}}
            callDocument={callDocument}
          />
        )}
      </div>
      <br />
      {!loading ? (
        <Circle />
      ) : (
        <div className="w-full">
          <TableComplete
            header={[
              {
                name: "label",
                label: "Campo",
              },
              {
                name: "description",
                label: "Monto",
              },
              {
                name: "description3",
                label: "Cantidad",
              },
              // {
              //   name: "description2",
              //   label: "Planilla",
              // },
              // {
              //   name: "observation",
              //   label: "Diferencia",
              // },
              {
                name: "add",
                type: "action",
                label: "Opciones",
                sticky: true,
                actions: [
                  {
                    label: "Editar tabla",
                    icon: "fas fa-table",
                    action: handleFormItems,
                    color: "text-[#1d4ed8]",
                  },
                  {
                    label: "Editar",
                    icon: "fas  fa-edit",
                    action: handleForm,
                    color: "text-[#1d4ed8]",
                  },
                  {
                    label: "Añadir",
                    icon: "fas fa-trash",
                    action: handleDelete,
                    color: "text-red-500",
                  },
                ],
              },
            ]}
            data={data}
          />
        </div>
      )}
    </div>
  );
};

const FormAddDocument = (props) => {
  const { data, item = null, reload, field, onClose, callDocument } = props;
  const initialValues = {
    Label: item?.label ? item.label : validateArray(data) ? data[0].name : "",
    NumberValue: item?.numberValue ? item.numberValue : 0,
    Description: item?.description ? item.description : "0.00",     //Monto
    Description2: item?.description2 ? item.description2 : "",      //formTable
    Description3: item?.description3 ? item.description3 : "1.00",     //cantidad
    Description4: item?.description4 ? item.description4 : "",      //Modelo Moto
    isNew: false,
  }
  const [values, setValues] = useState(initialValues);

  async function handleSubmit() {
    const payload = {
      ...values,
      // si está en modo moto, concatenamos Label(Moto) + Modelo
      Label: showMotoField
        ? `${values.Label}${values.Description4 ? ' - ' + values.Description4 : ''}`
        : values.Label,
    };
    if (values.isNew) {
      await handleCreateOption(values);
    }
    await requestAuth(
      item ? "put" : "post",
      item
        ? `/dataSet/procedure/subData/${item.id}`
        : `/dataSet/procedure/${field.id}/field/${field.fieldId}/subdata`,
      payload
    )
      .then(() => {
        reload();
        onClose();
        setValues(initialValues);
        toast.success("Registro exitoso");
      })
      .catch(() => {
        toast.error("Se produjo un error al guardar");
      });
  }

  const [showMotoField, setShowMotoField] = useState(false);

  async function handleCreateOption(value) {
    await requestAuth("post", "/Dropdown/Option", {
      Name: value.Label,
      DropdownListLabel: field.urlInitial,
    }).then(() => {
      callDocument();
    });
  }

  function handleChangeInp(e) {
    const { name, value } = e.target;
    setValues((a) => ({
      ...a,
      [name]: value,
    }));
  }
  function handleChange(e) {
    setValues((a) => ({
      ...a,
      Label: e.value,
      isNew: e.__isNew__ || false,
    }));
    setShowMotoField(e.value.includes("Motocicleta"));
  }

  return (
    <form className="flex flex-col">
      {validateArray(data) ? (
        <div className="flex flex-row gap-2 [&>*]:flex-1">
          <div>
            <Label>Lista de campos</Label>
            <CreatableSelect
              isSearchable={true}
              onChange={handleChange}
              styles={{
                placeholder: (base) => ({
                  ...base,
                  color: "black",
                }),
              }}
              // defaultInputValue={values[field.name]}
              placeholder={"Seleccionar..."}
              isOptionSelected={false}
              // isLoading={field.urlApi ? !loading : false}
              options={data.map((option) => ({
                value: option.name,
                label: option.name,
              }))}
            />

          </div>
          {showMotoField && (
            <div>
              <Label>Modelo</Label> <br />
              <input
                value={values.Description4}
                onChange={handleChangeInp}
                className="w-full px-2 py-1.5 rounded-md"
                type="text"
                name="Description4"
              />
            </div>
          )}
        </div>
      ) : null}
      <div className={`flex gap-2 ${item ? "flex-col" : ""}`}>
        {!showMotoField && (
          <>
            <div className="w-full">
              <Label className={`my-0 mt-4`}>{item ? "Monto proforma" : "Monto"}</Label> <br />
              <input
                value={values.Description}
                onChange={handleChangeInp}
                className="w-full p-2 rounded-md"
                type="text"
                name="Description"
              />
            </div>
          </>
        )}
        {showMotoField && (
          <>
            <div className="w-full">
              <Label className={`my-0 mt-4`}>Cantidad</Label> <br />
              <input
                value={values.Description3}
                onChange={handleChangeInp}
                className="w-full p-2 rounded-md"
                type="text"
                name="Description3"
              />
            </div>
          </>
        )}
        {/* {item ? (
          <>
            <Label className={`my-0 mt-1`}>Monto planilla</Label>
            <input
              value={values.Description2}
              onChange={handleChangeInp}
              className="w-full p-2 rounded-md"
              type="text"
              name="Description2"
            />
          </>
        ) : null} */}
        <Button
          onClick={handleSubmit}
          className={`px-3 h-10 mt-6 ${item ? "mt-2 py-3" : "py-0"}`}
        >
          Guardar
        </Button>
      </div>
    </form>
  );
};

export default InputSubContaMultiAdd;
